import { render, staticRenderFns } from "./FolderEditModal.vue?vue&type=template&id=49b4f774"
import script from "./FolderEditModal.vue?vue&type=script&lang=ts"
export * from "./FolderEditModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49b4f774')) {
      api.createRecord('49b4f774', component.options)
    } else {
      api.reload('49b4f774', component.options)
    }
    module.hot.accept("./FolderEditModal.vue?vue&type=template&id=49b4f774", function () {
      api.rerender('49b4f774', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tasks/FolderEditModal.vue"
export default component.exports